import { render } from "./ColorBlock.vue?vue&type=template&id=652f1576&scoped=true"
import script from "./ColorBlock.vue?vue&type=script&lang=js"
export * from "./ColorBlock.vue?vue&type=script&lang=js"

import "./ColorBlock.vue?vue&type=style&index=0&id=652f1576&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-652f1576"

export default script